import ReactOnRails from 'react-on-rails';
import * as SurveysComponents from '../registrations/surveys_components';

// Note: We don't need everything in SurveysComponents for the public,
// but it's easier to just import them all atm.
function registerPublicReactComponents() {
  ReactOnRails.register({
    ...SurveysComponents,
  });
}

export default registerPublicReactComponents;
